/*
    Actions for opening calendar forms

    Current dependencies make directly importing the compose initialization
    utils difficult, so these actions are provided to allow opening the forms
    without breaking the dependency tree. The orchestrators for these actions
    are registered on boot.

    For any consumers of Calendar forms from the following directories (the
    core Calendar packages), please continue directly using the utils in
    owa-calendar-compose-form-lifecycle:

        - apps/calendar
        - calendar
        - calendar-common

    TODO: Break the dependency graph issues between Calendar and Mail
    https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/126431
*/

// Open Calendar Compose
export { launchCalendarFullCompose } from './actions/launchCalendarFullCompose';
export { launchCalendarFullComposeToDuplicate } from './actions/launchCalendarFullComposeToDuplicate';

// Open Calendar Reading Pane
export { launchCalendarReadingPane } from './actions/launchCalendarReadingPane';
